import { useEffect, useRef } from "react";

// Track if Calendly script is already loaded globally
let isCalendlyScriptLoaded = false;

const CalendlyModal = ({ prefill }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isCalendlyScriptLoaded) {
      const script = document.createElement("script");
      script.id = "calendly-script";
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      script.onload = () => {
        isCalendlyScriptLoaded = true;
        initCalendly();
      };
      document.body.appendChild(script);
    } else {
      initCalendly();
    }

    function initCalendly() {
      if (window.Calendly && containerRef.current) {
        containerRef.current.innerHTML = "";

        window.Calendly.initInlineWidget({
          url2: "https://calendly.com/nasim-x-mondal/30min?background_color=ffffff00",
          url: "https://calendly.com/founder-prashasync/10min?background_color=E9EEFF",
                    
          parentElement: containerRef.current,
          prefill: prefill || {},
        });

        // Ensure iframe transparency once injected
        /*const checkIframe = setInterval(() => {
          const iframe = containerRef.current.querySelector("iframe");
          if (iframe) {
            iframe.style.background = "transparent";
            iframe.setAttribute("allowtransparency", "true");
            clearInterval(checkIframe);
          }
        }, 300);*/
      }
    }
  }, [prefill]);

  return (
    <div
      ref={containerRef}
      style={{
        height: "80%", // Fixed height
        width: "100%",
        background: "transparent", // container background
      }}
    />
  );
};

export default CalendlyModal;
